import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";

export const ContactUs = () => {
  return (
    <Box
      minHeight="calc(100vh - 370px);"
      display="flex"
      flexDirection="column"
      alignItems="center"
      
    >
      <Box p="80px 95px 20px" width="1280px">
        <Typography variant="bold" fontSize="40px" color="white">
          Contact us
        </Typography>

        <Box
          width="262px"
          sx={{
            cursor: "pointer",
          }}
          onClick={() => {
            window.location.href = "mailto:contact@wetez.io";
          }}
        >
          <Typography variant="bold" fontSize="20px" color="primary" mt="20px">
            Support: contact@wetez.io
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
